"use strict";

exports.__esModule = true;
exports.createEditableCallback = exports.isInDisabledFieldset = void 0;

var _react = require("react");

var _useEventCallback = _interopRequireDefault(require("@restart/hooks/useEventCallback"));

var _matches = _interopRequireDefault(require("dom-helpers/query/matches"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isInDisabledFieldset = function isInDisabledFieldset(node) {
  return !!node && (0, _matches.default)(node, 'fieldset[disabled] *');
};

exports.isInDisabledFieldset = isInDisabledFieldset;

function createCallback(disabled, ref, fn) {
  return (0, _useEventCallback.default)(function () {
    var inDisabledFieldset = ref.current && isInDisabledFieldset(ref.current);
    if (inDisabledFieldset || disabled == true) return;
    return fn.apply(void 0, arguments);
  });
}

var createEditableCallback = function createEditableCallback(disabled, ref) {
  return (0, _react.useCallback)(function (fn) {
    return createCallback(disabled, ref, fn);
  }, [disabled, ref]);
};

exports.createEditableCallback = createEditableCallback;